(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-share-copy]');
    if (!button) return;

    var label = button.querySelector('[data-share-copy-label]');
    var originalText = label.textContent;

    navigator.clipboard.writeText(button.dataset.url).then(function () {
      label.textContent = button.dataset.copiedText;
      setTimeout(function () {
        label.textContent = originalText;
      }, 2000);
    });
  });

  document.querySelectorAll('.article__faq .faq__question').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.closest('.faq__item');
      var isOpen = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', isOpen);

      var icon = button.querySelector('.faq__icon');
      if (icon) {
        icon.src = isOpen ? icon.dataset.iconOpen : icon.dataset.iconClosed;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var form = document.querySelector('.cart-page__form');
    if (!form) return;

    function certificateKeysFor(variantId) {
      if (!variantId) return [];
      return Array.prototype.map.call(
        form.querySelectorAll('[data-cart-item][data-certificate-for="' + variantId + '"]'),
        function (el) { return el.getAttribute('data-key'); }
      );
    }

    function removeItemAndCertificates(itemEl) {
      var updates = {};
      updates[itemEl.getAttribute('data-key')] = 0;
      certificateKeysFor(itemEl.getAttribute('data-variant-id')).forEach(function (key) {
        updates[key] = 0;
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      }).then(function () {
        window.location.reload();
      });
    }

    function submitUpdate() {
      var updateBtn = form.querySelector('[name="update"]');
      if (form.requestSubmit) {
        form.requestSubmit(updateBtn);
      } else {
        updateBtn.click();
      }
    }

    form.addEventListener('click', function (e) {
      var removeLink = e.target.closest('[data-cart-item-remove]');
      if (removeLink) {
        e.preventDefault();
        removeItemAndCertificates(removeLink.closest('[data-cart-item]'));
        return;
      }

      var stepBtn = e.target.closest('[data-qty-step]');
      if (!stepBtn) return;

      var itemEl = stepBtn.closest('[data-cart-item]');
      var qtyInput = itemEl.querySelector('.cart-item__qty-input');
      var next = parseInt(qtyInput.value, 10) + parseInt(stepBtn.getAttribute('data-qty-step'), 10);
      if (isNaN(next) || next < 0) next = 0;

      if (next === 0) {
        removeItemAndCertificates(itemEl);
        return;
      }

      qtyInput.value = next;
      submitUpdate();
    });

    form.addEventListener('submit', function () {
      form.querySelectorAll('[data-cart-item]').forEach(function (itemEl) {
        var qtyInput = itemEl.querySelector('.cart-item__qty-input');
        if (!qtyInput || qtyInput.value !== '0') return;

        certificateKeysFor(itemEl.getAttribute('data-variant-id')).forEach(function (key) {
          var fieldName = 'updates[' + key + ']';
          if (form.querySelector('[name="' + fieldName + '"]')) return;
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = fieldName;
          hidden.value = '0';
          form.appendChild(hidden);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('SolFacetFiltersForm');
    if (!form) return;

    var sidebar = document.getElementById('shop-sidebar');
    var sidebarMQ = window.matchMedia('(max-width: 1199px)');

    function isInsideMobileDrawer(target) {
      return sidebarMQ.matches && sidebar && sidebar.contains(target);
    }

    document.addEventListener('change', function (event) {
      if (event.target.form !== form && !form.contains(event.target)) return;

      if (event.target.matches('[data-price-preset]')) {
        var minField = form.querySelector('[data-price-min-field]');
        var maxField = form.querySelector('[data-price-max-field]');
        if (minField) minField.value = event.target.getAttribute('data-min');
        if (maxField) maxField.value = event.target.getAttribute('data-max');
      }

      if (event.target.matches('input[type="checkbox"], input[type="number"], input[type="radio"], select')) {
        if (isInsideMobileDrawer(event.target)) {
          scheduleResultCountPreview();
        } else {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      }
    });

    form.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-filter-more-toggle]');
      if (!toggle) return;

      var group = toggle.closest('.filter-group');
      if (!group) return;

      var isExpanded = group.classList.toggle('is-expanded');
      toggle.textContent = isExpanded ? toggle.getAttribute('data-less-label') : toggle.getAttribute('data-more-label');
    });

    var toggleBtn = document.getElementById('filter-toggle-btn');
    var sidebarBackdrop = document.getElementById('shop-sidebar-backdrop');
    var sidebarCloseBtn = document.getElementById('shop-sidebar-close');
    var sidebarClearBtn = document.getElementById('shop-sidebar-clear');
    var sidebarApplyBtn = document.getElementById('shop-sidebar-apply');

    function openMobileDrawer() {
      if (!sidebar) return;
      sidebar.classList.add('is-open');
      sidebar.setAttribute('aria-hidden', 'false');
      if (sidebarBackdrop) sidebarBackdrop.classList.add('is-visible');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMobileDrawer() {
      if (!sidebar) return;
      sidebar.classList.remove('is-open');
      sidebar.setAttribute('aria-hidden', 'true');
      if (sidebarBackdrop) sidebarBackdrop.classList.remove('is-visible');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (toggleBtn && sidebar) {
      toggleBtn.addEventListener('click', function () {
        if (sidebarMQ.matches) {
          openMobileDrawer();
        } else {
          var isOpen = sidebar.classList.toggle('is-open');
          toggleBtn.setAttribute('aria-expanded', isOpen);
        }
      });
    }

    if (sidebarCloseBtn) sidebarCloseBtn.addEventListener('click', closeMobileDrawer);
    if (sidebarBackdrop) sidebarBackdrop.addEventListener('click', closeMobileDrawer);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && sidebar && sidebar.classList.contains('is-open')) closeMobileDrawer();
    });

    var resultCountTimer = null;
    function scheduleResultCountPreview() {
      if (!sidebarApplyBtn) return;
      window.clearTimeout(resultCountTimer);
      resultCountTimer = window.setTimeout(fetchResultCountPreview, 300);
    }

    function fetchResultCountPreview() {
      if (!sidebarApplyBtn) return;
      var params = new URLSearchParams(new FormData(form));
      var query = params.toString();
      var url = window.location.pathname + (query ? '?' + query : '');
      sidebarApplyBtn.dataset.targetUrl = url;

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var loadMore = doc.getElementById('SolLoadMoreWrapper');
          var count;
          if (loadMore) {
            count = parseInt(loadMore.getAttribute('data-total'), 10);
          } else {
            count = doc.querySelectorAll('#SolProductGrid .shop__grid-item').length;
          }
          if (!isNaN(count)) {
            sidebarApplyBtn.textContent = sidebarApplyBtn.getAttribute('data-count-template').replace('%%COUNT%%', count);
          }
        })
        .catch(function () {});
    }

    if (sidebarApplyBtn) {
      sidebarApplyBtn.addEventListener('click', function () {
        window.location.href = sidebarApplyBtn.dataset.targetUrl || sidebarApplyBtn.getAttribute('data-target-url');
      });
    }

    if (sidebarClearBtn && sidebar) {
      sidebarClearBtn.addEventListener('click', function () {
        sidebar.querySelectorAll('input[type="checkbox"]').forEach(function (input) { input.checked = false; });
        sidebar.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = false; });
        sidebar.querySelectorAll('input[type="number"]').forEach(function (input) { input.value = ''; });
        var minField = form.querySelector('[data-price-min-field]');
        var maxField = form.querySelector('[data-price-max-field]');
        if (minField) minField.value = '';
        if (maxField) maxField.value = '';
        fetchResultCountPreview();
      });
    }

    var grid = document.getElementById('SolProductGrid');
    var loadMoreWrapper = document.getElementById('SolLoadMoreWrapper');
    if (grid && loadMoreWrapper) {
      loadMoreWrapper.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-load-more-btn]');
        if (!btn) return;
        event.preventDefault();
        if (btn.classList.contains('is-loading')) return;

        var url = btn.getAttribute('href');
        var originalLabel = btn.textContent;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = loadMoreWrapper.getAttribute('data-loading-label');

        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('SolProductGrid');
            var newWrapper = doc.getElementById('SolLoadMoreWrapper');

            if (newGrid) {
              Array.prototype.forEach.call(newGrid.querySelectorAll('.shop__grid-item'), function (item) {
                grid.appendChild(item);
              });
            }

            if (newWrapper) {
              loadMoreWrapper.innerHTML = newWrapper.innerHTML;
              loadMoreWrapper.setAttribute('data-total', newWrapper.getAttribute('data-total'));
            } else {
              loadMoreWrapper.remove();
            }

            history.replaceState(history.state, '', url);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            btn.textContent = originalLabel;
          });
      });
    }
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var el = document.getElementById('announce-text');
  if (!el) return;
  var raw = el.dataset.messages || '';
  var msgs = raw.split('|').map(function(m) { return m.trim(); }).filter(Boolean);
  if (msgs.length < 2) return;
  var idx = 0;
  setInterval(function () {
    el.classList.add('announce__text--exit');
    setTimeout(function () {
      idx = (idx + 1) % msgs.length;
      el.textContent = msgs[idx];
      el.classList.remove('announce__text--exit');
      el.classList.add('announce__text--enter');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.remove('announce__text--enter');
        });
      });
    }, 320);
  }, 4000);
})();

// Mobile submenu toggles
document.querySelectorAll('.nav__mobile-toggle').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var submenu = btn.closest('li').querySelector('.nav__mobile-submenu');
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    submenu.setAttribute('aria-hidden', expanded ? 'true' : 'false');
    submenu.classList.toggle('is-open', !expanded);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'solacely_recently_viewed';
    var handle = document.body.dataset.productHandle;
    if (!handle) return;

    var handles = [];
    try {
      handles = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      handles = [];
    }

    handles = handles.filter(function (existing) { return existing !== handle; });
    handles.unshift(handle);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, 12)));
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    var grid = document.getElementById('SolSearchGrid');
    var loadMoreWrapper = document.getElementById('SolSearchLoadMoreWrapper');
    if (!grid || !loadMoreWrapper) return;

    loadMoreWrapper.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-load-more-btn]');
      if (!btn) return;
      event.preventDefault();
      if (btn.classList.contains('is-loading')) return;

      var url = btn.getAttribute('href');
      var originalLabel = btn.textContent;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = loadMoreWrapper.getAttribute('data-loading-label');

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('SolSearchGrid');
          var newWrapper = doc.getElementById('SolSearchLoadMoreWrapper');

          if (newGrid) {
            Array.prototype.forEach.call(newGrid.querySelectorAll('.search-page__item'), function (item) {
              grid.appendChild(item);
            });
          }

          if (newWrapper) {
            loadMoreWrapper.innerHTML = newWrapper.innerHTML;
            loadMoreWrapper.setAttribute('data-total', newWrapper.getAttribute('data-total'));
          } else {
            loadMoreWrapper.remove();
          }

          history.replaceState(history.state, '', url);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.textContent = originalLabel;
        });
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-blog-category-filter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.cat-filter__nav').forEach(function (nav) {
      var track = nav.querySelector('.cat-filter__track');
      var prev = nav.querySelector('.cat-filter__arrow--prev');
      var next = nav.querySelector('.cat-filter__arrow--next');
      if (!track || !prev || !next) return;

      function update() {
        var sl = track.scrollLeft;
        var max = track.scrollWidth - track.clientWidth;
        nav.classList.toggle('cf-has-prev', sl > 2);
        nav.classList.toggle('cf-has-next', max > 2 && sl < max - 2);
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      prev.addEventListener('click', function () { track.scrollBy({ left: -280, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: 280, behavior: 'smooth' }); });
      update();
    });
  }());



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-blog-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-blog-grid-paginated]').forEach(function (grid) {
    var cards = grid.querySelector('[data-blog-grid-cards]');
    var more = grid.querySelector('[data-blog-grid-more]');
    if (!cards || !more) return;

    var btn = more.querySelector('[data-blog-grid-load-more]');
    var countEl = more.querySelector('[data-blog-grid-count]');
    if (!btn) return;

    var perPage = parseInt(grid.dataset.perPage, 10) || 12;
    var totalCount = parseInt(grid.dataset.totalCount, 10) || 0;
    var countTemplate = countEl ? countEl.dataset.countTemplate || '' : '';
    var nextUrl = grid.dataset.nextUrl || '';

    function hiddenCards() {
      return cards.querySelectorAll('.blog-grid__card-wrap[hidden]');
    }

    function reveal() {
      Array.prototype.slice.call(hiddenCards(), 0, perPage).forEach(function (card) {
        card.removeAttribute('hidden');
      });

      if (countEl && countTemplate) {
        var shown = cards.querySelectorAll('.blog-grid__card-wrap:not([hidden])').length;
        countEl.textContent = countTemplate.replace('__SHOWN__', shown).replace('__TOTAL__', totalCount);
      }

      if (!hiddenCards().length && !nextUrl) btn.hidden = true;
    }

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      if (btn.classList.contains('is-loading')) return;

      // Still have pre-rendered cards in the pool: just show the next batch.
      if (hiddenCards().length) {
        reveal();
        return;
      }
      if (!nextUrl) return;

      var url = nextUrl;
      var originalLabel = btn.textContent;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = more.getAttribute('data-loading-label') || originalLabel;

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById(grid.id);
          if (!newGrid) throw new Error('grid missing');

          Array.prototype.forEach.call(newGrid.querySelectorAll('.blog-grid__card-wrap'), function (card) {
            card.setAttribute('hidden', '');
            cards.appendChild(card);
          });

          nextUrl = newGrid.dataset.nextUrl || '';
          grid.dataset.nextUrl = nextUrl;

          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.textContent = originalLabel;
          reveal();
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.textContent = originalLabel;
        });
    });
  });

  document.querySelectorAll('[data-all-blogs-grid]').forEach(function (grid) {
    var loadBtn = grid.querySelector('[data-all-blogs-load-more]');
    var countEl = grid.querySelector('[data-all-blogs-count]');
    if (!loadBtn || !countEl) return;

    var perPage = parseInt(grid.dataset.perPage, 10) || 12;
    var countTemplate = countEl.dataset.countTemplate || '';
    var totalCount = parseInt(grid.dataset.totalCount, 10) || grid.querySelectorAll('.blog-grid__card-wrap').length;

    loadBtn.addEventListener('click', function () {
      var extras = Array.prototype.slice.call(grid.querySelectorAll('[data-all-blogs-extra]'), 0, perPage);
      extras.forEach(function (card) {
        card.removeAttribute('hidden');
        card.removeAttribute('data-all-blogs-extra');
      });

      var shownCount = grid.querySelectorAll('.blog-grid__card-wrap:not([hidden])').length;
      if (countTemplate) {
        countEl.textContent = countTemplate.replace('__SHOWN__', shownCount).replace('__TOTAL__', totalCount);
      }

      if (!grid.querySelector('[data-all-blogs-extra]')) {
        loadBtn.hidden = true;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-blog-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-promo-tags]').forEach(function (tagList) {
      var section = tagList.closest('.blog-promo');
      if (!section) return;
      var panels = section.querySelector('[data-promo-panels]');
      if (!panels) return;

      tagList.addEventListener('click', function (event) {
        var tag = event.target.closest('[data-promo-tag]');
        if (!tag || !tagList.contains(tag)) return;

        tagList.querySelectorAll('[data-promo-tag]').forEach(function (btn) {
          btn.classList.remove('blog-promo__tag--active');
          btn.setAttribute('aria-selected', 'false');
        });
        tag.classList.add('blog-promo__tag--active');
        tag.setAttribute('aria-selected', 'true');

        var targetId = tag.dataset.target;
        panels.querySelectorAll('[data-promo-panel]').forEach(function (panel) {
          var isTarget = panel.id === targetId;
          panel.classList.toggle('blog-promo__panel--active', isTarget);
          panel.hidden = !isTarget;
        });
      });
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-collection-filter-bar"] && !Shopify.designMode) return;
  try {
    
 (function () {
    document.querySelectorAll('.cat-filter__nav').forEach(function (nav) {
      var track = nav.querySelector('.cat-filter__track');
      var prev = nav.querySelector('.cat-filter__arrow--prev');
      var next = nav.querySelector('.cat-filter__arrow--next');
      if (!track || !prev || !next) return;

      function update() {
        var sl = track.scrollLeft;
        var max = track.scrollWidth - track.clientWidth;
        nav.classList.toggle('cf-has-prev', sl > 2);
        nav.classList.toggle('cf-has-next', max > 2 && sl < max - 2);
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      prev.addEventListener('click', function () { track.scrollBy({ left: -280, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: 280, behavior: 'smooth' }); });
      update();
    });
  }());

  (function () {
    var shippingEl = document.getElementById('cat-filter-shipping');
    if (shippingEl) {
      var thresholdCents = parseInt(shippingEl.dataset.thresholdCents, 10);
      var awayTemplate = shippingEl.dataset.awayTemplate;
      var unlockedHtml = shippingEl.dataset.unlockedHtml;
      var totalTemplate = shippingEl.dataset.totalTemplate;
      var box = shippingEl.querySelector('[data-shipping-box]');
      var message = shippingEl.querySelector('[data-shipping-message]');
      var track = shippingEl.querySelector('[data-shipping-track]');
      var fill = shippingEl.querySelector('[data-shipping-fill]');
      var total = shippingEl.querySelector('[data-shipping-total]');
      var cartLink = shippingEl.querySelector('[data-shipping-cart-link]');

      // A price as HTML in the shop's own money_format - the markup and string
      // shape the currency converter recognises. Intl.NumberFormat output in
      // Shopify.currency.active (the store's base currency) was invisible to it.
      function moneyHTML(cents) {
        return window.SolacelyMoney.markup(cents);
      }

      function updateShippingBar(cart) {
        if (!thresholdCents) return;
        var remaining = Math.max(thresholdCents - cart.total_price, 0);
        var progress = Math.min((cart.total_price * 100) / thresholdCents, 100);
        var unlocked = remaining === 0;

        box.classList.toggle('cat-filter__shipping--unlocked', unlocked);
        message.innerHTML = unlocked
          ? unlockedHtml
          : awayTemplate.replace(
              '%%AMOUNT%%',
              '<span class="cat-filter__shipping-highlight">' + moneyHTML(remaining) + ' away</span>'
            );
        fill.style.width = progress + '%';
        track.setAttribute('aria-valuenow', progress);
        total.innerHTML = totalTemplate
          .replace('%%CURRENT%%', moneyHTML(cart.total_price))
          .replace('%%THRESHOLD%%', moneyHTML(thresholdCents));
        window.SolacelyMoney.refresh(box);
        total.hidden = unlocked;
        cartLink.hidden = !cart.item_count || cart.total_price <= 0;
      }

      document.addEventListener('solacely:cart-updated', function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(updateShippingBar);
      });
    }
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-collection-info"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.col-info__faq-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.col-info__faq-item');
      var isOpen = item.classList.toggle('col-info__faq-item--open');
      var answer = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', isOpen);
      if (isOpen) {
        answer.removeAttribute('hidden');
      } else {
        answer.setAttribute('hidden', '');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-consultations-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq__question').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.closest('.faq__item');
      var isOpen = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', isOpen);

      var icon = button.querySelector('.faq__icon');
      if (icon) {
        icon.src = isOpen ? icon.dataset.iconOpen : icon.dataset.iconClosed;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-contact-showroom"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-contact-showroom]').forEach((section) => {
    const slides = Array.from(section.querySelectorAll('[data-showroom-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-showroom-dot]'));
    if (slides.length < 2) return;

    let index = 0;

    function go(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('contact-showroom__slide--active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('contact-showroom__dot--active', i === index));
    }

    const prev = section.querySelector('[data-showroom-prev]');
    const next = section.querySelector('[data-showroom-next]');
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-custom-bracelet-builder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cb-root]').forEach(function (root) {
    var section = root.closest('.cb-builder');

    var track = section.querySelector('[data-cb-track]');
    if (track) {
      var slides = track.querySelectorAll('[data-cb-slide]');
      var cur = 0;
      var goTo = function (n) {
        slides[cur].classList.remove('cb-builder__slide--active');
        cur = (n + slides.length) % slides.length;
        slides[cur].classList.add('cb-builder__slide--active');
      };
      var prevBtn = section.querySelector('[data-cb-prev]');
      var nextBtn = section.querySelector('[data-cb-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(cur - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(cur + 1); });
    }

    var minCrystals = 2;
    var crystalBtns = Array.prototype.slice.call(root.querySelectorAll('[data-cb-crystal]'));
    var beadBtns = Array.prototype.slice.call(root.querySelectorAll('[data-cb-bead]'));
    var wristBtns = Array.prototype.slice.call(root.querySelectorAll('[data-cb-wrist]'));
    var charmBtns = Array.prototype.slice.call(root.querySelectorAll('[data-cb-charm]'));
    var fitBtns = Array.prototype.slice.call(root.querySelectorAll('[data-cb-fit]'));

    var hidden = {
      crystals: root.querySelector('[data-cb-hidden="crystals"]'),
      bead: root.querySelector('[data-cb-hidden="bead"]'),
      wrist: root.querySelector('[data-cb-hidden="wrist"]'),
      charm: root.querySelector('[data-cb-hidden="charm"]'),
      fit: root.querySelector('[data-cb-hidden="fit"]')
    };
    var summary = {
      crystals: section.querySelector('[data-cb-summary="crystals"]'),
      bead: section.querySelector('[data-cb-summary="bead"]'),
      wrist: section.querySelector('[data-cb-summary="wrist"]'),
      charm: section.querySelector('[data-cb-summary="charm"]'),
      fit: section.querySelector('[data-cb-summary="fit"]')
    };
    var optval = {
      crystals: root.querySelector('[data-cb-optval="crystals"]'),
      bead: root.querySelector('[data-cb-optval="bead"]'),
      wrist: root.querySelector('[data-cb-optval="wrist"]'),
      charm: root.querySelector('[data-cb-optval="charm"]'),
      fit: root.querySelector('[data-cb-optval="fit"]')
    };

    function activeCrystals() {
      return crystalBtns.filter(function (b) { return b.classList.contains('cb-builder__crystal--active'); });
    }

    function syncCrystals() {
      var names = activeCrystals().map(function (b) { return b.getAttribute('data-name'); });
      var text = names.join(', ');
      if (hidden.crystals) hidden.crystals.value = names.length >= minCrystals ? text : '';
      if (summary.crystals) summary.crystals.textContent = text;
      if (optval.crystals) optval.crystals.textContent = 'Crystal: ' + names.join(' | ');
    }

    crystalBtns.forEach(function (btn) {
      if (btn.getAttribute('data-default') === 'true') btn.classList.add('cb-builder__crystal--active');
      btn.addEventListener('click', function () {
        if (btn.classList.contains('cb-builder__crystal--active')) {
          if (activeCrystals().length > minCrystals) btn.classList.remove('cb-builder__crystal--active');
        } else {
          btn.classList.add('cb-builder__crystal--active');
        }
        syncCrystals();
      });
    });

    var crystalToggle = root.querySelector('[data-cb-crystal-toggle]');
    if (crystalToggle) {
      var extraCrystals = Array.prototype.slice.call(root.querySelectorAll('.cb-builder__crystal--extra'));
      // Keep a pre-selected crystal from being hidden behind the toggle.
      var expanded = extraCrystals.some(function (b) { return b.getAttribute('data-default') === 'true'; });

      function renderCrystalToggle() {
        extraCrystals.forEach(function (b) { b.hidden = !expanded; });
        crystalToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        crystalToggle.textContent = crystalToggle.getAttribute(expanded ? 'data-less' : 'data-more');
      }

      crystalToggle.addEventListener('click', function () {
        expanded = !expanded;
        renderCrystalToggle();
      });

      renderCrystalToggle();
    }

    function singleSelect(btns, activeClass, hiddenInput, summaryEl, optvalEl, optPrefix) {
      function select(btn) {
        btns.forEach(function (b) { b.classList.remove(activeClass); });
        btn.classList.add(activeClass);
        var value = btn.getAttribute('data-value');
        var label = btn.getAttribute('data-summary');
        if (hiddenInput) hiddenInput.value = value;
        if (summaryEl) summaryEl.textContent = label;
        if (optvalEl) optvalEl.textContent = optPrefix + ': ' + label;
      }
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () { select(btn); });
        if (btn.getAttribute('data-default') === 'true') select(btn);
      });
    }

    singleSelect(beadBtns, 'cb-builder__size-btn--active', hidden.bead, summary.bead, optval.bead, 'Bead size');
    singleSelect(wristBtns, 'cb-builder__wrist-btn--active', hidden.wrist, summary.wrist, optval.wrist, 'Wrist size');
    singleSelect(charmBtns, 'cb-builder__charm-btn--active', hidden.charm, summary.charm, optval.charm, 'Add a charm');
    singleSelect(fitBtns, 'cb-builder__fit-btn--active', hidden.fit, summary.fit, optval.fit, 'Fit');

    syncCrystals();

    var sizeGuideDrawer = document.getElementById('size-guide-drawer');
    var sizeGuideBackdrop = document.getElementById('size-guide-backdrop');
    var sizeGuideClose = document.getElementById('size-guide-drawer-close');

    if (sizeGuideDrawer && sizeGuideBackdrop) {
      var openSizeGuide = function () {
        sizeGuideDrawer.classList.add('is-open');
        sizeGuideBackdrop.classList.add('is-visible');
        sizeGuideDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (sizeGuideClose) sizeGuideClose.focus();
      };

      var closeSizeGuide = function () {
        sizeGuideDrawer.classList.remove('is-open');
        sizeGuideBackdrop.classList.remove('is-visible');
        sizeGuideDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      root.querySelectorAll('[data-size-guide-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', openSizeGuide);
      });

      if (sizeGuideClose) sizeGuideClose.addEventListener('click', closeSizeGuide);
      sizeGuideBackdrop.addEventListener('click', closeSizeGuide);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeGuideDrawer.classList.contains('is-open')) closeSizeGuide();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-custom-bracelet-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cb-gallery-toggle]');
    if (!toggle) return;
    var grid = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!grid) return;
    var expanded = grid.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? toggle.getAttribute('data-label-less') : toggle.getAttribute('data-label-more');
    if (!expanded) grid.closest('.cb-gallery').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.querySelectorAll('[data-cb-gallery]').forEach(function (grid) {
    var lightbox = document.querySelector('[data-cb-lightbox]');
    if (!lightbox) return;

    var image = lightbox.querySelector('[data-cb-lightbox-image]');
    var triggers = Array.prototype.slice.call(grid.querySelectorAll('[data-cb-gallery-trigger]'));
    var current = 0;
    var lastFocused = null;

    function show(index) {
      current = (index + triggers.length) % triggers.length;
      var trigger = triggers[current];
      image.src = trigger.getAttribute('data-full');
      image.alt = trigger.getAttribute('data-alt') || '';
    }

    function open(index) {
      lastFocused = document.activeElement;
      show(index);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      lightbox.querySelector('[data-cb-lightbox-close]').focus();
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () { open(index); });
    });

    lightbox.querySelector('[data-cb-lightbox-close]').addEventListener('click', close);
    lightbox.querySelector('[data-cb-lightbox-prev]').addEventListener('click', function () { show(current - 1); });
    lightbox.querySelector('[data-cb-lightbox-next]').addEventListener('click', function () { show(current + 1); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-custom-bracelet-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getStep(track) {
      var card = track.querySelector('.cb-reviews__card');
      return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    }

    function update(track) {
      var section = track.closest('.cb-reviews');
      var prev = section.querySelector('[data-cb-reviews-prev]');
      var next = section.querySelector('[data-cb-reviews-next]');
      var dots = section.querySelector('[data-cb-reviews-dots]');
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;

      if (!dots) return;
      var step = getStep(track);
      var cards = track.querySelectorAll('.cb-reviews__card').length;
      var perView = Math.max(1, Math.round((track.clientWidth + parseFloat(getComputedStyle(track).columnGap || 0)) / step));
      var count = Math.max(1, cards - perView + 1);
      var active = track.scrollLeft >= max ? count - 1 : Math.round(track.scrollLeft / step);

      if (dots.children.length !== count) {
        dots.innerHTML = '';
        for (var i = 0; i < count; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cb-reviews__dot';
          dot.setAttribute('data-cb-reviews-dot', i);
          dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
          dots.appendChild(dot);
        }
      }
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        var isActive = i === active;
        dot.classList.toggle('is-active', isActive);
        if (isActive) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    }

    function init(root) {
      root.querySelectorAll('[data-cb-reviews-track]').forEach(function (track) {
        if (track.dataset.cbReviewsReady) return;
        track.dataset.cbReviewsReady = 'true';
        track.addEventListener('scroll', function () { update(track); }, { passive: true });
        window.addEventListener('resize', function () { update(track); });
        update(track);
      });
    }

    document.addEventListener('click', function (event) {
      var control = event.target.closest('[data-cb-reviews-prev], [data-cb-reviews-next], [data-cb-reviews-dot]');
      if (!control) return;
      var track = control.closest('.cb-reviews').querySelector('[data-cb-reviews-track]');
      if (!track) return;
      var step = getStep(track);
      if (control.hasAttribute('data-cb-reviews-dot')) {
        track.scrollTo({ left: Number(control.getAttribute('data-cb-reviews-dot')) * step });
      } else {
        track.scrollBy({ left: control.hasAttribute('data-cb-reviews-prev') ? -step : step });
      }
    });

    init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.hero__track').forEach(function (track) {
    var slides = track.querySelectorAll('.hero__slide');
    var dots   = track.parentElement.querySelectorAll('.hero__dot');
    if (slides.length < 2) return;

    var current  = 0;
    var autoplay = track.dataset.autoplay === 'true';
    var speed    = parseInt(track.dataset.speed, 10) || 5000;
    var timer;

    function activate(n) {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
      if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
    }

    function startTimer() {
      if (autoplay) timer = setInterval(function () { activate(current + 1); }, speed);
    }
    function stopTimer() { clearInterval(timer); }

    startTimer();

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { stopTimer(); activate(i); startTimer(); });
    });

    track.parentElement.addEventListener('mouseenter', stopTimer);
    track.parentElement.addEventListener('mouseleave', startTimer);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-offer-codes"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-offer-copy]').forEach(function (chip) {
    var ctaEl = chip.querySelector('[data-copy-cta]');
    var defaultCta = ctaEl ? ctaEl.textContent : '';
    var confirmedCta = chip.getAttribute('data-confirmed-text') || defaultCta;

    chip.addEventListener('click', function () {
      var value = chip.getAttribute('data-copy-value');
      if (!value || !navigator.clipboard) return;

      navigator.clipboard.writeText(value).then(function () {
        if (!ctaEl) return;
        ctaEl.textContent = confirmedCta;
        setTimeout(function () { ctaEl.textContent = defaultCta; }, 2000);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'solacely_recently_viewed';
    var section = document.getElementById('recently-viewed');
    var grid = document.getElementById('recently-viewed-grid');
    if (!section || !grid) return;

    var maxProducts = parseInt(section.dataset.maxProducts, 10) || 4;
    var currentHandle = document.body.dataset.productHandle || '';

    var handles = [];
    try {
      handles = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      handles = [];
    }

    handles = handles.filter(function (handle) { return handle !== currentHandle; }).slice(0, maxProducts);
    if (!handles.length) return;

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '?view=solacely-card')
          .then(function (res) { return res.ok ? res.text() : null; })
          .catch(function () { return null; });
      })
    ).then(function (htmlFragments) {
      htmlFragments.filter(Boolean).forEach(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.card');
        if (card) grid.appendChild(card);
      });

      if (grid.children.length) {
        section.hidden = false;
      }
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-ruling-result"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ruling-result]').forEach(function (root) {
    var dataEl = root.querySelector('[data-ruling-data]');
    var data = [];
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = []; }

    var form = root.querySelector('[data-ruling-form]');
    var dayField = root.querySelector('[data-ruling-day]');
    var numberEl = root.querySelector('[data-ruling-number]');
    var titleEl = root.querySelector('[data-ruling-title]');
    var planetEl = root.querySelector('[data-ruling-planet]');
    var descEl = root.querySelector('[data-ruling-desc]');
    var linksEl = root.querySelector('[data-ruling-links]');
    var planetTemplate = planetEl ? planetEl.textContent.replace(/[^·]+$/, '{{ planet }}') : '';

    function digitalRoot(day) {
      var n = day % 9;
      return n === 0 ? 9 : n;
    }

    function linkHtml(link) {
      return '<a href="' + link.url + '" class="ruling-result__standalone-link">' + link.text + '</a>';
    }

    function render(number) {
      var entry = data.filter(function (d) { return d.number === number; })[0];
      if (!entry) return;
      numberEl.textContent = entry.number;
      titleEl.textContent = entry.title;
      planetEl.textContent = planetTemplate.replace('{{ planet }}', entry.planet);
      descEl.textContent = entry.desc;
      if (linksEl) {
        linksEl.innerHTML = (entry.links || []).map(linkHtml).join('');
      }
      document.dispatchEvent(new CustomEvent('solacely:ruling-number-changed', { detail: { number: number } }));
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        render(digitalRoot(parseInt(dayField.value, 10)));
      });
    }

    var copyBtn = root.querySelector('[data-ruling-copy]');
    if (copyBtn) {
      var copyLabel = copyBtn.textContent;
      var confirmedText = copyBtn.getAttribute('data-confirmed-text') || copyLabel;
      copyBtn.addEventListener('click', function () {
        var text = 'My ruling number is ' + numberEl.textContent + ' — ' + titleEl.textContent;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(function () {
            copyBtn.textContent = confirmedText;
            setTimeout(function () { copyBtn.textContent = copyLabel; }, 2000);
          });
        }
      });
    }

    var shareBtn = root.querySelector('[data-ruling-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var shareData = { title: document.title, text: titleEl.textContent, url: window.location.href };
        if (navigator.share) {
          navigator.share(shareData).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href);
        }
      });
    }

    var recalcBtn = root.querySelector('[data-ruling-recalculate]');
    if (recalcBtn) {
      recalcBtn.addEventListener('click', function () {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        dayField.focus();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solacely-ruling-stack"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ruling-stack]').forEach(function (root) {
    var dataEl = root.querySelector('[data-ruling-stack-data]');
    var data = [];
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = []; }

    var headingEl = root.querySelector('[data-ruling-stack-heading]');
    var textEl = root.querySelector('[data-ruling-stack-text]');
    var gridEl = root.querySelector('[data-ruling-stack-grid]');

    function cardHtml(product) {
      var onBody = product.onBodyLabel ? '<span class="sp-stack__on-body">' + product.onBodyLabel + '</span>' : '';
      var stone = product.stoneText ? '<p class="sp-stack__stone">' + product.stoneText + '</p>' : '';
      var img = product.image ? '<img src="' + product.image + '" alt="' + product.title + '" loading="lazy" width="400" height="400">' : '';
      return (
        '<a href="' + product.url + '" class="sp-stack__card">' +
          '<div class="sp-stack__img">' + img + onBody + '</div>' +
          '<div class="sp-stack__body">' +
            '<h3 class="sp-stack__name">' + product.title + '</h3>' +
            stone +
            '<p class="sp-stack__price">' + product.price + '</p>' +
          '</div>' +
        '</a>'
      );
    }

    function render(number) {
      var entry = data.filter(function (d) { return d.number === number; })[0];
      if (!entry) {
        root.hidden = true;
        return;
      }
      root.hidden = false;
      if (headingEl && entry.heading) headingEl.textContent = entry.heading;
      if (textEl && entry.text) textEl.textContent = entry.text;
      if (gridEl) gridEl.innerHTML = (entry.products || []).map(cardHtml).join('');
    }

    document.addEventListener('solacely:ruling-number-changed', function (e) {
      var number = e.detail && e.detail.number;
      if (number) render(number);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
